module.exports = __webpack_public_path__ + "img/footer-bg.65bfdb97.png";